// Descriptions are sent to the model on every processed meeting, so they are
// capped to keep the per-meeting prompt from growing with the catalog.
export const DESCRIPTION_MAX_LENGTH = 300

// Minimal, curated palette for category colors (two rows of six)
export const COLOR_OPTIONS = [
  '#1F2937', // slate-800
  '#9CA3AF', // gray-400
  '#F87171', // red-400
  '#FB7185', // rose-400
  '#A78BFA', // violet-400
  '#60A5FA', // blue-400
  '#38BDF8', // sky-400
  '#34D399', // emerald-400
  '#22C55E', // green-500
  '#A3E635', // lime-400
  '#FACC15', // yellow-400
  '#FB923C', // orange-400
]


